import React from "react";

const UserManagementList = React.lazy(() => import('src/pages/user_management/UserManagementList'));
const AddUserManagement = React.lazy(() => import('src/pages/user_management/AddUserManagement'));
const EditUserManagement = React.lazy(() => import('src/pages/user_management/EditUserManagement'));

const routes = [
    { path: '/dashboard/user-management-list/add', name: 'Add', element: AddUserManagement },
    { path: '/dashboard/user-management-list/edit', name: 'Edit', element: EditUserManagement },
    { path: '/dashboard/user-management-list', name: 'User Management', element: UserManagementList },
];

export default routes;
